import type { Client, DashboardStats, RevenueDataPoint, TeamMember, Task, Project, Deal, Campaign, CalendarEvent, Invoice, InvoiceItem, Expense, AttendanceRecord, LeaveBalance } from '../types'

// ── Dashboard Stats ───────────────────────────
export const mockStats: DashboardStats = {
  totalMRR: 1480000,
  mrrGrowth: 12.3,
  activeClients: 11,
  newClientsThisMonth: 2,
  activeProjects: 8,
  projectsCompletedThisMonth: 3,
  pendingInvoices: 4,
  overdueAmount: 240000,
  totalExpensesThisMonth: 320000,
  teamUtilization: 78,
}

// ── Revenue Chart Data (12 months) ────────────
export const mockRevenueData: RevenueDataPoint[] = [
  { month: 'May',  revenue: 780000,  expenses: 210000, profit: 570000 },
  { month: 'Jun',  revenue: 820000,  expenses: 230000, profit: 590000 },
  { month: 'Jul',  revenue: 910000,  expenses: 260000, profit: 650000 },
  { month: 'Aug',  revenue: 960000,  expenses: 275000, profit: 685000 },
  { month: 'Sep',  revenue: 1020000, expenses: 290000, profit: 730000 },
  { month: 'Oct',  revenue: 1100000, expenses: 305000, profit: 795000 },
  { month: 'Nov',  revenue: 1180000, expenses: 315000, profit: 865000 },
  { month: 'Dec',  revenue: 1250000, expenses: 340000, profit: 910000 },
  { month: 'Jan',  revenue: 1190000, expenses: 325000, profit: 865000 },
  { month: 'Feb',  revenue: 1320000, expenses: 310000, profit: 1010000 },
  { month: 'Mar',  revenue: 1410000, expenses: 318000, profit: 1092000 },
  { month: 'Apr',  revenue: 1480000, expenses: 320000, profit: 1160000 },
]

// ── Clients ───────────────────────────────────
export const mockClients: Client[] = [
  {
    id: 'c1',
    name: 'Astra Fintech',
    contact: 'Rohan Mehta',
    email: 'rohan@astrafintech.in',
    phone: '+91 98200 11234',
    services: ['Google Ads', 'SEO', 'Social'],
    mrr: 220000,
    status: 'active',
    joinedAt: '2023-04-15',
  },
  {
    id: 'c2',
    name: 'Skyforge Studios',
    contact: 'Priya Nair',
    email: 'priya@skyforgeit.com',
    phone: '+91 97300 45678',
    services: ['Meta Ads', 'Email'],
    mrr: 185000,
    status: 'active',
    joinedAt: '2023-06-01',
  },
  {
    id: 'c3',
    name: 'Blaze Commerce',
    contact: 'Amit Shah',
    email: 'amit@blazecommerce.co',
    phone: '+91 96100 78901',
    services: ['Google Ads', 'Meta Ads', 'SEO'],
    mrr: 175000,
    status: 'active',
    joinedAt: '2023-07-20',
  },
  {
    id: 'c4',
    name: 'Nexora Health',
    contact: 'Dr. Sneha Joshi',
    email: 'sneha@nexorahealth.in',
    phone: '+91 95200 34567',
    services: ['SEO', 'Social'],
    mrr: 140000,
    status: 'active',
    joinedAt: '2023-09-05',
  },
  {
    id: 'c5',
    name: 'Vortex Logistics',
    contact: 'Karan Singh',
    email: 'karan@vortexlog.in',
    phone: '+91 94300 56789',
    services: ['Google Ads', 'Email'],
    mrr: 130000,
    status: 'active',
    joinedAt: '2023-10-12',
  },
  {
    id: 'c6',
    name: 'Pixel Republic',
    contact: 'Divya Sharma',
    email: 'divya@pixelrepublic.io',
    phone: '+91 93400 67890',
    services: ['Meta Ads', 'Social', 'Email'],
    mrr: 120000,
    status: 'active',
    joinedAt: '2023-11-01',
  },
  {
    id: 'c7',
    name: 'CoreEdge Tech',
    contact: 'Nikhil Bose',
    email: 'nikhil@coreedge.tech',
    phone: '+91 92500 78901',
    services: ['Google Ads', 'SEO'],
    mrr: 115000,
    status: 'active',
    joinedAt: '2023-11-18',
  },
  {
    id: 'c8',
    name: 'Zenith Retail',
    contact: 'Aanya Kapoor',
    email: 'aanya@zenithretail.com',
    phone: '+91 91600 89012',
    services: ['Meta Ads', 'Email'],
    mrr: 110000,
    status: 'active',
    joinedAt: '2023-12-03',
  },
  {
    id: 'c9',
    name: 'Luminary Labs',
    contact: 'Rahul Verma',
    email: 'rahul@luminarylabs.in',
    phone: '+91 90700 90123',
    services: ['SEO', 'Social'],
    mrr: 95000,
    status: 'active',
    joinedAt: '2024-01-15',
  },
  {
    id: 'c10',
    name: 'Titan Edu',
    contact: 'Meera Pillai',
    email: 'meera@titanedu.co.in',
    phone: '+91 89800 01234',
    services: ['Google Ads'],
    mrr: 90000,
    status: 'active',
    joinedAt: '2024-02-20',
  },
  {
    id: 'c11',
    name: 'Nova Digital',
    contact: 'Siddharth Rao',
    email: 'sid@novadigital.in',
    phone: '+91 88900 12345',
    services: ['Meta Ads', 'SEO'],
    mrr: 100000,
    status: 'active',
    joinedAt: '2024-03-01',
  },
  {
    id: 'c12',
    name: 'Orbit Systems',
    contact: 'Fatima Khan',
    email: 'fatima@orbitsys.in',
    phone: '+91 87700 23456',
    services: ['Google Ads', 'Social'],
    mrr: 80000,
    status: 'inactive',
    joinedAt: '2023-08-10',
  },
  {
    id: 'c13',
    name: 'GrowFast Ventures',
    contact: 'Arun Pillai',
    email: 'arun@growfastventures.in',
    phone: '+91 86600 34567',
    services: ['SEO', 'Content'],
    mrr: 0,
    status: 'prospect',
    joinedAt: '2026-04-01',
  },
  {
    id: 'c14',
    name: 'Indira Fashions',
    contact: 'Nisha Malhotra',
    email: 'nisha@indirafashions.com',
    phone: '+91 85500 45678',
    services: ['Meta Ads', 'Google Ads', 'Social'],
    mrr: 0,
    status: 'prospect',
    joinedAt: '2026-04-02',
  },
  {
    id: 'c15',
    name: 'MedFirst Health',
    contact: 'Dr. Rajesh Kumar',
    email: 'rajesh@medfirsthealth.in',
    phone: '+91 84400 56789',
    services: ['Google Ads', 'SEO'],
    mrr: 0,
    status: 'prospect',
    joinedAt: '2026-04-05',
  },
]

// ── Recent Activity ───────────────────────────
export interface ActivityItem {
  id: string
  type: 'invoice_paid' | 'project_started' | 'new_client' | 'project_done' | 'campaign_launched' | 'overdue_alert'
  description: string
  detail: string
  timeAgo: string
}

export const mockActivity: ActivityItem[] = [
  {
    id: 'a1',
    type: 'invoice_paid',
    description: 'Invoice #INV-0042 paid',
    detail: 'Astra Fintech • ₹2,20,000',
    timeAgo: '12 min ago',
  },
  {
    id: 'a2',
    type: 'new_client',
    description: 'New client onboarded',
    detail: 'Nova Digital • SEO + Meta Ads',
    timeAgo: '2 hrs ago',
  },
  {
    id: 'a3',
    type: 'project_started',
    description: 'Project kicked off',
    detail: 'Blaze Commerce — Q2 Ads Overhaul',
    timeAgo: '5 hrs ago',
  },
  {
    id: 'a4',
    type: 'campaign_launched',
    description: 'Google Ads campaign launched',
    detail: 'Titan Edu • Budget ₹90,000/mo',
    timeAgo: 'Yesterday',
  },
  {
    id: 'a5',
    type: 'project_done',
    description: 'Project marked complete',
    detail: 'Nexora Health — SEO Audit 2024',
    timeAgo: 'Yesterday',
  },
  {
    id: 'a6',
    type: 'overdue_alert',
    description: 'Invoice overdue alert',
    detail: 'Orbit Systems • ₹80,000 — 14 days late',
    timeAgo: '2 days ago',
  },
]

// ── Team Members ──────────────────────────────
export const mockTeamMembers: TeamMember[] = [
  {
    id: 'tm-bunny',
    name: 'Bunny',
    role: 'Founder — Production',
    email: 'bunny@nexuserp.com',
    skills: ['Content', 'Production', 'Projects', 'Scheduling'],
    utilization: 85,
    activeProjects: 5,
    hoursThisMonth: 160,
    status: 'active',
    joinedAt: '2022-01-01',
  },
  {
    id: 'tm-hj',
    name: 'HJ',
    role: 'Founder — Sales & Ops',
    email: 'hj@nexuserp.com',
    skills: ['Sales', 'Strategy', 'Operations', 'Pipeline'],
    utilization: 88,
    activeProjects: 6,
    hoursThisMonth: 168,
    status: 'active',
    joinedAt: '2022-01-01',
  },
  {
    id: 'tm-darshu',
    name: 'Darshu',
    role: 'Founder — Paid Ads',
    email: 'darshu@nexuserp.com',
    skills: ['Google Ads', 'Meta Ads', 'Analytics', 'Budget'],
    utilization: 90,
    activeProjects: 6,
    hoursThisMonth: 172,
    status: 'active',
    joinedAt: '2022-01-01',
  },
  {
    id: 'tm-rahul',
    name: 'Rahul',
    role: 'SEO Specialist',
    email: 'rahul@nexuserp.com',
    skills: ['SEO', 'Content', 'Analytics', 'Backlinks'],
    utilization: 72,
    activeProjects: 4,
    hoursThisMonth: 142,
    status: 'active',
    joinedAt: '2024-03-01',
  },
  {
    id: 'tm-priya',
    name: 'Priya',
    role: 'Content Writer',
    email: 'priya@nexuserp.com',
    skills: ['Copywriting', 'Social', 'Email', 'SEO Content'],
    utilization: 78,
    activeProjects: 4,
    hoursThisMonth: 148,
    status: 'active',
    joinedAt: '2024-03-01',
  },
  {
    id: 'tm-pooja',
    name: 'Pooja',
    role: 'Ads Manager',
    email: 'pooja@nexuserp.com',
    skills: ['Meta Ads', 'Google Ads', 'Retargeting', 'Creatives'],
    utilization: 91,
    activeProjects: 5,
    hoursThisMonth: 170,
    status: 'active',
    joinedAt: '2024-03-01',
  },
  {
    id: 'tm-amit',
    name: 'Amit',
    role: 'Sales Executive',
    email: 'amit@nexuserp.com',
    skills: ['Sales', 'CRM', 'Pitching', 'Pipeline'],
    utilization: 80,
    activeProjects: 3,
    hoursThisMonth: 152,
    status: 'active',
    joinedAt: '2024-03-01',
  },
  {
    id: 'tm-dev',
    name: 'Dev',
    role: 'Operations',
    email: 'dev@nexuserp.com',
    skills: ['Operations', 'Looker Studio', 'Reporting', 'Onboarding'],
    utilization: 68,
    activeProjects: 3,
    hoursThisMonth: 134,
    status: 'active',
    joinedAt: '2024-03-01',
  },
]

// ── Tasks (main ERP view — founders see all) ──
export const mockTasks: Task[] = [
  {
    id: 't1',
    title: 'Set up Google Ads conversion tracking for Titan Edu',
    description: 'Implement GTM-based conversion tracking for lead form submissions.',
    priority: 'urgent',
    status: 'todo',
    assignee: 'Amit',
    projectId: 'p3',
    projectName: 'Titan Edu — Q2 Ads',
    dueDate: '2026-04-02',
    tags: ['Google Ads', 'GTM'],
    createdAt: '2026-03-28',
  },
  {
    id: 't2',
    title: 'Write April content calendar for Blaze Commerce',
    description: 'Plan 30 days of social + blog content aligned with product launches.',
    priority: 'high',
    status: 'todo',
    assignee: 'Priya',
    projectId: 'p1',
    projectName: 'Blaze Commerce — Q2 Ads Overhaul',
    dueDate: '2026-04-05',
    tags: ['Social', 'Content'],
    createdAt: '2026-03-29',
  },
  {
    id: 't3',
    title: 'Conduct technical SEO audit for Nexora Health',
    description: 'Full crawl, Core Web Vitals, schema, and backlink review.',
    priority: 'high',
    status: 'todo',
    assignee: 'Rahul',
    projectId: 'p2',
    projectName: 'Nexora Health — SEO Audit',
    dueDate: '2026-04-08',
    tags: ['SEO', 'Audit'],
    createdAt: '2026-03-30',
  },
  {
    id: 't4',
    title: 'Design new landing page wireframes for Astra Fintech',
    description: 'High-fidelity Figma wireframes for the revamped lead gen page.',
    priority: 'medium',
    status: 'todo',
    assignee: 'Dev',
    projectId: 'p4',
    projectName: 'Astra Fintech — Landing Pages',
    dueDate: '2026-04-10',
    tags: ['Figma', 'UX'],
    createdAt: '2026-03-30',
  },
  {
    id: 't5',
    title: 'Launch Meta retargeting campaign for Skyforge Studios',
    description: 'Set up custom audience and dynamic product ads on Meta.',
    priority: 'urgent',
    status: 'in-progress',
    assignee: 'Pooja',
    projectId: 'p5',
    projectName: 'Skyforge — Meta Retargeting',
    dueDate: '2026-04-03',
    tags: ['Meta Ads', 'Retargeting'],
    createdAt: '2026-03-27',
  },
  {
    id: 't6',
    title: 'Build April performance dashboard in Looker Studio',
    description: 'Multi-client report with ROAS, CTR, and revenue KPIs.',
    priority: 'medium',
    status: 'in-progress',
    assignee: 'Dev',
    projectName: 'Internal — Reporting',
    dueDate: '2026-04-06',
    tags: ['Analytics', 'Looker'],
    createdAt: '2026-03-28',
  },
  {
    id: 't7',
    title: 'Draft Q2 strategy deck for Vortex Logistics',
    description: 'Include channel mix, budget allocation, and forecasted ROAS.',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Amit',
    projectId: 'p6',
    projectName: 'Vortex Logistics — Q2 Strategy',
    dueDate: '2026-04-07',
    tags: ['Strategy', 'Deck'],
    createdAt: '2026-03-29',
  },
  {
    id: 't8',
    title: 'A/B test email subject lines for Zenith Retail',
    description: 'Run 3-variant subject line test on the April promo email.',
    priority: 'medium',
    status: 'in-progress',
    assignee: 'Pooja',
    projectId: 'p7',
    projectName: 'Zenith Retail — Email Flows',
    dueDate: '2026-04-09',
    tags: ['Email', 'Testing'],
    createdAt: '2026-03-30',
  },
  {
    id: 't9',
    title: 'Review Meta Ads creative for Pixel Republic',
    description: 'Creative QA before going live — check copy, visuals, CTAs.',
    priority: 'high',
    status: 'review',
    assignee: 'Pooja',
    projectId: 'p8',
    projectName: 'Pixel Republic — Meta Ads',
    dueDate: '2026-04-04',
    tags: ['Meta Ads', 'Creative'],
    createdAt: '2026-03-26',
  },
  {
    id: 't10',
    title: 'Peer review SEO keyword mapping spreadsheet',
    description: 'Cross-check target keywords, search intent, and page assignments.',
    priority: 'low',
    status: 'review',
    assignee: 'Rahul',
    projectName: 'Internal — SEO Templates',
    dueDate: '2026-04-11',
    tags: ['SEO', 'Keywords'],
    createdAt: '2026-03-31',
  },
  {
    id: 't11',
    title: 'Final delivery: CoreEdge Tech website redesign',
    description: 'Hand off all final Figma files and live Webflow build.',
    priority: 'high',
    status: 'review',
    assignee: 'Dev',
    projectId: 'p9',
    projectName: 'CoreEdge — Website Redesign',
    dueDate: '2026-04-05',
    tags: ['Webflow', 'Handoff'],
    createdAt: '2026-03-25',
  },
  {
    id: 't12',
    title: 'Complete March Google Ads report for Astra Fintech',
    description: 'Monthly report with insights, optimisations, and next steps.',
    priority: 'medium',
    status: 'done',
    assignee: 'Amit',
    projectId: 'p4',
    projectName: 'Astra Fintech — Landing Pages',
    dueDate: '2026-03-31',
    tags: ['Google Ads', 'Reporting'],
    createdAt: '2026-03-20',
  },
  {
    id: 't13',
    title: 'Onboard Nova Digital into Clickbait workspace',
    description: 'Add client, create project folders, set up Slack channel.',
    priority: 'low',
    status: 'done',
    assignee: 'Dev',
    dueDate: '2026-03-30',
    tags: ['Onboarding'],
    createdAt: '2026-03-28',
  },
  {
    id: 't14',
    title: 'Publish SEO blog post: "Top 10 Fintech Marketing Trends 2026"',
    description: 'Final edit, featured image, and publish on Astra blog.',
    priority: 'medium',
    status: 'done',
    assignee: 'Priya',
    projectId: 'p2',
    projectName: 'Nexora Health — SEO Audit',
    dueDate: '2026-03-28',
    tags: ['Content', 'SEO'],
    createdAt: '2026-03-22',
  },
]

// ── Employee seed tasks (RealtimeContext initial state) ───────
// These populate each employee's Kanban on first load.
// A founder assigning tasks via the Team page adds to this store.
export const mockEmployeeTasks: Task[] = [
  // ── Amit (Sales Executive → HJ) ──
  {
    id: 'et-a1',
    title: 'Follow up with Orbit Systems on renewal proposal',
    description: 'Send personalised renewal deck and schedule a call this week.',
    priority: 'urgent',
    status: 'todo',
    assignee: 'Amit',
    projectName: 'Orbit Systems — Renewal',
    dueDate: '2026-04-09',
    tags: ['Sales', 'Renewal'],
    createdAt: '2026-04-05',
  },
  {
    id: 'et-a2',
    title: 'Prepare Q2 pitch deck for Titan Edu meeting',
    description: 'Build a data-driven proposal showing Q1 results and Q2 forecast.',
    priority: 'high',
    status: 'todo',
    assignee: 'Amit',
    projectId: 'p3',
    projectName: 'Titan Edu — Q2 Ads',
    dueDate: '2026-04-12',
    tags: ['Sales', 'Pitch'],
    createdAt: '2026-04-04',
  },
  {
    id: 'et-a3',
    title: 'Create April sales pipeline report',
    description: 'Summarise deal stages, expected close dates, and revenue forecast.',
    priority: 'medium',
    status: 'in-progress',
    assignee: 'Amit',
    projectName: 'Internal — Reporting',
    dueDate: '2026-04-10',
    tags: ['Sales', 'Reporting'],
    createdAt: '2026-04-03',
  },
  {
    id: 'et-a4',
    title: 'Draft proposal for new fintech client lead',
    description: 'Tailor service deck based on discovery call notes from 3 April.',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Amit',
    projectName: 'New Business — Fintech Lead',
    dueDate: '2026-04-08',
    tags: ['Sales', 'Proposal'],
    createdAt: '2026-04-03',
  },
  {
    id: 'et-a5',
    title: 'Update CRM with March client interactions',
    description: 'Log all calls, emails, and meeting notes from March into HubSpot.',
    priority: 'low',
    status: 'review',
    assignee: 'Amit',
    projectName: 'Internal — CRM',
    dueDate: '2026-04-07',
    tags: ['CRM', 'Admin'],
    createdAt: '2026-04-01',
  },
  {
    id: 'et-a6',
    title: 'Close Luminary Labs contract renewal',
    description: 'Finalise MSA, collect signed copy, update billing details.',
    priority: 'medium',
    status: 'done',
    assignee: 'Amit',
    projectName: 'Luminary Labs — Renewal',
    dueDate: '2026-03-31',
    tags: ['Sales', 'Contract'],
    createdAt: '2026-03-25',
  },

  // ── Rahul (SEO Specialist → Bunny) ──
  {
    id: 'et-r1',
    title: 'Keyword research for Nexora Health Q2 blog',
    description: 'Find 50 target keywords across health, wellness, and fintech verticals.',
    priority: 'high',
    status: 'todo',
    assignee: 'Rahul',
    projectId: 'p2',
    projectName: 'Nexora Health — SEO Audit',
    dueDate: '2026-04-10',
    tags: ['SEO', 'Keywords'],
    createdAt: '2026-04-04',
  },
  {
    id: 'et-r2',
    title: 'Fix Core Web Vitals for Astra Fintech',
    description: 'Improve LCP, CLS, and FID scores to green across key landing pages.',
    priority: 'urgent',
    status: 'in-progress',
    assignee: 'Rahul',
    projectId: 'p4',
    projectName: 'Astra Fintech — Landing Pages',
    dueDate: '2026-04-08',
    tags: ['SEO', 'Performance'],
    createdAt: '2026-04-02',
  },
  {
    id: 'et-r3',
    title: 'Build Q2 backlink outreach list',
    description: 'Identify 30 high-DA sites for guest post and link exchange outreach.',
    priority: 'medium',
    status: 'in-progress',
    assignee: 'Rahul',
    projectName: 'Internal — Link Building',
    dueDate: '2026-04-14',
    tags: ['SEO', 'Outreach'],
    createdAt: '2026-04-03',
  },
  {
    id: 'et-r4',
    title: 'On-page SEO for 5 Blaze Commerce category pages',
    description: 'Meta titles, descriptions, H1s, schema markup, and internal links.',
    priority: 'high',
    status: 'review',
    assignee: 'Rahul',
    projectId: 'p1',
    projectName: 'Blaze Commerce — Q2 Ads Overhaul',
    dueDate: '2026-04-06',
    tags: ['SEO', 'On-page'],
    createdAt: '2026-03-31',
  },
  {
    id: 'et-r5',
    title: 'Publish "Top Fintech Marketing Trends 2026" blog post',
    description: 'Final edit, add featured image, schedule publish on Astra blog.',
    priority: 'medium',
    status: 'done',
    assignee: 'Rahul',
    projectId: 'p2',
    projectName: 'Nexora Health — SEO Audit',
    dueDate: '2026-03-28',
    tags: ['Content', 'SEO'],
    createdAt: '2026-03-22',
  },

  // ── Priya (Content Writer → Bunny) ──
  {
    id: 'et-p1',
    title: 'Write 4 social captions for Skyforge Studios April campaign',
    description: 'Platform-native captions for Instagram, LinkedIn, and Twitter.',
    priority: 'high',
    status: 'todo',
    assignee: 'Priya',
    projectId: 'p5',
    projectName: 'Skyforge — Meta Retargeting',
    dueDate: '2026-04-09',
    tags: ['Social', 'Copywriting'],
    createdAt: '2026-04-05',
  },
  {
    id: 'et-p2',
    title: 'Script YouTube ad for Blaze Commerce spring sale',
    description: '30-second hook + value prop + CTA script. Two variants.',
    priority: 'medium',
    status: 'todo',
    assignee: 'Priya',
    projectId: 'p1',
    projectName: 'Blaze Commerce — Q2 Ads Overhaul',
    dueDate: '2026-04-11',
    tags: ['Video', 'Copywriting'],
    createdAt: '2026-04-04',
  },
  {
    id: 'et-p3',
    title: 'Write April content calendar for Skyforge Studios',
    description: '30-day social + blog plan aligned with product and campaign dates.',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Priya',
    projectId: 'p5',
    projectName: 'Skyforge — Meta Retargeting',
    dueDate: '2026-04-07',
    tags: ['Content', 'Planning'],
    createdAt: '2026-04-02',
  },
  {
    id: 'et-p4',
    title: 'Draft Q2 email newsletter for Zenith Retail',
    description: 'Promotional email with product highlights, discount code, and CTA.',
    priority: 'medium',
    status: 'in-progress',
    assignee: 'Priya',
    projectId: 'p7',
    projectName: 'Zenith Retail — Email Flows',
    dueDate: '2026-04-10',
    tags: ['Email', 'Copywriting'],
    createdAt: '2026-04-03',
  },
  {
    id: 'et-p5',
    title: 'Submit SEO blog draft for Nexora Health review',
    description: '1,200-word article on "Digital Health Marketing in 2026".',
    priority: 'medium',
    status: 'done',
    assignee: 'Priya',
    projectId: 'p2',
    projectName: 'Nexora Health — SEO Audit',
    dueDate: '2026-03-30',
    tags: ['Content', 'SEO'],
    createdAt: '2026-03-24',
  },

  // ── Pooja (Ads Manager → Darshu) ──
  {
    id: 'et-po1',
    title: 'Set up Meta retargeting audiences for Pixel Republic',
    description: 'Build website visitor, add-to-cart, and lookalike audiences.',
    priority: 'urgent',
    status: 'todo',
    assignee: 'Pooja',
    projectId: 'p8',
    projectName: 'Pixel Republic — Meta Ads',
    dueDate: '2026-04-08',
    tags: ['Meta Ads', 'Audiences'],
    createdAt: '2026-04-05',
  },
  {
    id: 'et-po2',
    title: 'Optimise Google Ads ROAS for Blaze Commerce',
    description: 'Adjust bids, pause underperforming ad groups, test new headlines.',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Pooja',
    projectId: 'p1',
    projectName: 'Blaze Commerce — Q2 Ads Overhaul',
    dueDate: '2026-04-09',
    tags: ['Google Ads', 'Optimisation'],
    createdAt: '2026-04-03',
  },
  {
    id: 'et-po3',
    title: 'A/B test subject lines for Zenith Retail promo email',
    description: 'Run 3-variant test, analyse open rates, pick winner by Thursday.',
    priority: 'medium',
    status: 'in-progress',
    assignee: 'Pooja',
    projectId: 'p7',
    projectName: 'Zenith Retail — Email Flows',
    dueDate: '2026-04-10',
    tags: ['Email', 'Testing'],
    createdAt: '2026-04-02',
  },
  {
    id: 'et-po4',
    title: 'QA Meta creatives before Pixel Republic launch',
    description: 'Check copy, CTAs, visuals, and ad specs across all placements.',
    priority: 'high',
    status: 'review',
    assignee: 'Pooja',
    projectId: 'p8',
    projectName: 'Pixel Republic — Meta Ads',
    dueDate: '2026-04-05',
    tags: ['Meta Ads', 'QA'],
    createdAt: '2026-03-31',
  },
  {
    id: 'et-po5',
    title: 'Launch April Meta Ads for Skyforge Studios',
    description: 'Go live with approved creatives across Stories, Feed, and Reels.',
    priority: 'high',
    status: 'done',
    assignee: 'Pooja',
    projectId: 'p5',
    projectName: 'Skyforge — Meta Retargeting',
    dueDate: '2026-04-01',
    tags: ['Meta Ads', 'Launch'],
    createdAt: '2026-03-27',
  },

  // ── Dev (Operations → HJ) ──
  {
    id: 'et-d1',
    title: 'Update internal client onboarding SOP',
    description: 'Revise the 12-step onboarding checklist with new Clickbait tools.',
    priority: 'medium',
    status: 'todo',
    assignee: 'Dev',
    projectName: 'Internal — Operations',
    dueDate: '2026-04-14',
    tags: ['Operations', 'Documentation'],
    createdAt: '2026-04-05',
  },
  {
    id: 'et-d2',
    title: 'Build April Looker Studio performance dashboard',
    description: 'Multi-client report with ROAS, CTR, CPC, and revenue KPIs.',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Dev',
    projectName: 'Internal — Reporting',
    dueDate: '2026-04-08',
    tags: ['Analytics', 'Looker'],
    createdAt: '2026-04-02',
  },
  {
    id: 'et-d3',
    title: 'Set up Nova Digital onboarding in Clickbait',
    description: 'Create client profile, project folders, add to reporting pipeline.',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Dev',
    projectId: 'p11',
    projectName: 'Nova Digital — SEO + Content Audit',
    dueDate: '2026-04-09',
    tags: ['Onboarding', 'Operations'],
    createdAt: '2026-04-04',
  },
  {
    id: 'et-d4',
    title: 'Review and approve March expense reports',
    description: 'Cross-check all team expenses against budget, flag anomalies.',
    priority: 'medium',
    status: 'review',
    assignee: 'Dev',
    projectName: 'Internal — Finance',
    dueDate: '2026-04-06',
    tags: ['Finance', 'Admin'],
    createdAt: '2026-04-01',
  },
  {
    id: 'et-d5',
    title: 'Onboard Nova Digital into Clickbait workspace',
    description: 'Add client, create project folders, set up Slack channel.',
    priority: 'low',
    status: 'done',
    assignee: 'Dev',
    dueDate: '2026-03-30',
    tags: ['Onboarding'],
    createdAt: '2026-03-28',
  },
]

// ── Projects ──────────────────────────────────
export const mockProjects: Project[] = [
  { id: 'p1', title: 'Q2 Ads Overhaul', clientId: 'c3', clientName: 'Blaze Commerce', status: 'in-progress', priority: 'high', dueDate: '2026-04-30', assignees: ['Pooja', 'HJ'], description: 'Restructure entire Google + Meta ads setup for Q2.', progress: 45, tags: ['Paid Ads', 'Strategy'] },
  { id: 'p2', title: 'SEO Audit & Fix', clientId: 'c4', clientName: 'Nexora Health', status: 'in-progress', priority: 'high', dueDate: '2026-04-20', assignees: ['Rahul'], description: 'Technical SEO audit + on-page fixes.', progress: 60, tags: ['SEO'] },
  { id: 'p3', title: 'Q2 Google Ads', clientId: 'c10', clientName: 'Titan Edu', status: 'planning', priority: 'medium', dueDate: '2026-05-01', assignees: ['Pooja'], description: 'Set up and launch Q2 Google Ads campaigns.', progress: 15, tags: ['Google Ads'] },
  { id: 'p4', title: 'Landing Page Redesign', clientId: 'c1', clientName: 'Astra Fintech', status: 'in-progress', priority: 'high', dueDate: '2026-04-15', assignees: ['Dev'], description: 'Redesign lead-gen landing pages for better conversion.', progress: 70, tags: ['Web Dev', 'UX'] },
  { id: 'p5', title: 'Meta Retargeting Setup', clientId: 'c2', clientName: 'Skyforge Studios', status: 'in-progress', priority: 'medium', dueDate: '2026-04-10', assignees: ['Pooja', 'Priya'], description: 'Build retargeting funnel on Meta.', progress: 55, tags: ['Meta Ads'] },
  { id: 'p6', title: 'Q2 Strategy Deck', clientId: 'c5', clientName: 'Vortex Logistics', status: 'planning', priority: 'medium', dueDate: '2026-04-12', assignees: ['Amit'], description: 'Quarterly strategy presentation.', progress: 20, tags: ['Strategy'] },
  { id: 'p7', title: 'Email Automation Flows', clientId: 'c8', clientName: 'Zenith Retail', status: 'review', priority: 'medium', dueDate: '2026-04-08', assignees: ['Priya'], description: 'Build welcome + promo + win-back email flows.', progress: 85, tags: ['Email'] },
  { id: 'p8', title: 'April Meta Ads', clientId: 'c6', clientName: 'Pixel Republic', status: 'review', priority: 'high', dueDate: '2026-04-05', assignees: ['Pooja', 'Priya'], description: 'April creative rollout for Meta.', progress: 90, tags: ['Meta Ads', 'Creative'] },
  { id: 'p9', title: 'Website Redesign', clientId: 'c7', clientName: 'CoreEdge Tech', status: 'review', priority: 'high', dueDate: '2026-04-06', assignees: ['Dev'], description: 'Full Webflow website rebuild.', progress: 95, tags: ['Webflow', 'Design'] },
  { id: 'p10', title: 'Social Media Management', clientId: 'c9', clientName: 'Luminary Labs', status: 'in-progress', priority: 'low', dueDate: '2026-04-30', assignees: ['Priya'], description: 'Ongoing social media posting and engagement.', progress: 50, tags: ['Social'] },
  { id: 'p11', title: 'SEO + Content Audit', clientId: 'c11', clientName: 'Nova Digital', status: 'planning', priority: 'medium', dueDate: '2026-05-15', assignees: ['Rahul', 'Dev'], description: 'Initial onboarding audit for new client.', progress: 10, tags: ['SEO', 'Content'] },
  { id: 'p12', title: 'Google Ads Reactivation', clientId: 'c12', clientName: 'Orbit Systems', status: 'done', priority: 'low', dueDate: '2026-03-31', assignees: ['Pooja'], description: 'Reactivate paused campaigns post-budget approval.', progress: 100, tags: ['Google Ads'] },
]

// ── Pipeline Deals ────────────────────────────
export const mockDeals: Deal[] = [
  { id: 'd1', title: 'SEO Retainer — 6 months', company: 'GrowFast Ventures', contactName: 'Arun Pillai', value: 180000, stage: 'lead', probability: 20, expectedClose: '2026-05-15', notes: 'Found us via LinkedIn', createdAt: '2026-03-28' },
  { id: 'd2', title: 'Full-funnel Paid Ads', company: 'Indira Fashions', contactName: 'Nisha Malhotra', value: 250000, stage: 'lead', probability: 25, expectedClose: '2026-05-20', notes: 'Referral from Blaze Commerce', createdAt: '2026-03-30' },
  { id: 'd3', title: 'Google Ads Management', company: 'Agritech India', contactName: 'Suresh Patel', value: 120000, stage: 'qualified', probability: 40, expectedClose: '2026-04-30', notes: 'Budget confirmed at ₹1.2L/mo', createdAt: '2026-03-15' },
  { id: 'd4', title: 'Social + Email Package', company: 'Zippi Quick Commerce', contactName: 'Rina Dasgupta', value: 160000, stage: 'qualified', probability: 45, expectedClose: '2026-04-25', notes: 'Evaluating 2 other agencies', createdAt: '2026-03-18' },
  { id: 'd5', title: 'Performance Marketing Audit', company: 'MedFirst Health', contactName: 'Dr. Rajesh Kumar', value: 85000, stage: 'proposal', probability: 60, expectedClose: '2026-04-15', notes: 'Proposal sent on Apr 1', createdAt: '2026-03-10' },
  { id: 'd6', title: 'SEO + Content Retainer', company: 'Dharitri Foods', contactName: 'Kavita Iyer', value: 140000, stage: 'proposal', probability: 65, expectedClose: '2026-04-18', notes: 'Sent 3-month pilot proposal', createdAt: '2026-03-12' },
  { id: 'd7', title: 'Meta + Google Ads Full Setup', company: 'StyleForward', contactName: 'Pooja Khanna', value: 320000, stage: 'negotiation', probability: 75, expectedClose: '2026-04-10', notes: 'Negotiating on contract length', createdAt: '2026-02-25' },
  { id: 'd8', title: 'Annual Digital Marketing Retainer', company: 'Sahyog NGO', contactName: 'Ritu Sharma', value: 90000, stage: 'negotiation', probability: 80, expectedClose: '2026-04-08', notes: 'Special pricing requested', createdAt: '2026-03-01' },
  { id: 'd9', title: 'Web Dev + SEO Launch Package', company: 'Spiceroute Exports', contactName: 'Naveen Iyer', value: 275000, stage: 'closed-won', probability: 100, expectedClose: '2026-03-25', notes: 'Signed on Mar 25', createdAt: '2026-02-20' },
  { id: 'd10', title: 'Email Marketing Setup', company: 'TechStride Solutions', contactName: 'Ankit Gupta', value: 70000, stage: 'closed-won', probability: 100, expectedClose: '2026-03-20', notes: 'Contract signed', createdAt: '2026-03-05' },
  { id: 'd11', title: 'Influencer + Social Campaign', company: 'Glamora Beauty', contactName: 'Tanvi Desai', value: 200000, stage: 'closed-lost', probability: 0, expectedClose: '2026-03-15', notes: 'Went with a larger agency', createdAt: '2026-02-10' },
]

// ── Campaigns ─────────────────────────────────
export const mockCampaigns: Campaign[] = [
  { id: 'camp1', name: 'Astra Fintech — Google Search', clientId: 'c1', clientName: 'Astra Fintech', type: 'Google Ads', status: 'active', budget: 150000, spend: 112000, impressions: 320000, clicks: 8400, conversions: 210, revenue: 460000, roas: 4.1, startDate: '2026-01-01' },
  { id: 'camp2', name: 'Blaze Commerce — Meta Dynamic', clientId: 'c3', clientName: 'Blaze Commerce', type: 'Meta Ads', status: 'active', budget: 120000, spend: 98000, impressions: 580000, clicks: 14200, conversions: 340, revenue: 320000, roas: 3.27, startDate: '2026-02-01' },
  { id: 'camp3', name: 'Skyforge Studios — Meta Retargeting', clientId: 'c2', clientName: 'Skyforge Studios', type: 'Meta Ads', status: 'active', budget: 80000, spend: 55000, impressions: 210000, clicks: 5600, conversions: 98, revenue: 180000, roas: 3.27, startDate: '2026-03-01' },
  { id: 'camp4', name: 'Nexora Health — SEO Programme', clientId: 'c4', clientName: 'Nexora Health', type: 'SEO', status: 'active', budget: 60000, spend: 60000, impressions: 48000, clicks: 2200, conversions: 55, revenue: 95000, roas: 1.58, startDate: '2026-01-01' },
  { id: 'camp5', name: 'Vortex Logistics — Google Ads', clientId: 'c5', clientName: 'Vortex Logistics', type: 'Google Ads', status: 'active', budget: 90000, spend: 71000, impressions: 190000, clicks: 4100, conversions: 88, revenue: 260000, roas: 3.66, startDate: '2026-02-01' },
  { id: 'camp6', name: 'Pixel Republic — Meta Ads', clientId: 'c6', clientName: 'Pixel Republic', type: 'Meta Ads', status: 'active', budget: 70000, spend: 63000, impressions: 340000, clicks: 9800, conversions: 175, revenue: 195000, roas: 3.1, startDate: '2026-02-15' },
  { id: 'camp7', name: 'Zenith Retail — Email Promos', clientId: 'c8', clientName: 'Zenith Retail', type: 'Email', status: 'active', budget: 20000, spend: 18000, impressions: 42000, clicks: 5800, conversions: 290, revenue: 98000, roas: 5.44, startDate: '2026-01-01' },
  { id: 'camp8', name: 'CoreEdge Tech — SEO', clientId: 'c7', clientName: 'CoreEdge Tech', type: 'SEO', status: 'active', budget: 50000, spend: 50000, impressions: 32000, clicks: 1400, conversions: 38, revenue: 68000, roas: 1.36, startDate: '2026-01-01' },
  { id: 'camp9', name: 'Luminary Labs — Social', clientId: 'c9', clientName: 'Luminary Labs', type: 'Social', status: 'active', budget: 40000, spend: 38000, impressions: 120000, clicks: 3200, conversions: 42, revenue: 72000, roas: 1.89, startDate: '2026-03-01' },
  { id: 'camp10', name: 'Titan Edu — Google Ads', clientId: 'c10', clientName: 'Titan Edu', type: 'Google Ads', status: 'paused', budget: 90000, spend: 0, impressions: 0, clicks: 0, conversions: 0, revenue: 0, roas: 0, startDate: '2026-04-01' },
]

// ── Calendar Events ───────────────────────────
export const mockEvents: CalendarEvent[] = [
  { id: 'ev1', title: 'Monthly Reporting Call', date: '2026-04-04', time: '11:00', type: 'call', clientName: 'Astra Fintech', clientId: 'c1' },
  { id: 'ev2', title: 'Q2 Strategy Review — Blaze', date: '2026-04-07', time: '14:00', type: 'meeting', clientName: 'Blaze Commerce', clientId: 'c3' },
  { id: 'ev3', title: 'Meta Ads Go-Live', date: '2026-04-05', time: '10:00', type: 'deadline', clientName: 'Pixel Republic', clientId: 'c6' },
  { id: 'ev4', title: 'CoreEdge Website Handoff', date: '2026-04-06', time: '15:00', type: 'deadline', clientName: 'CoreEdge Tech', clientId: 'c7' },
  { id: 'ev5', title: 'SEO Review Call', date: '2026-04-08', time: '10:30', type: 'review', clientName: 'Nexora Health', clientId: 'c4' },
  { id: 'ev6', title: 'Vortex Q2 Strategy Presentation', date: '2026-04-12', time: '16:00', type: 'meeting', clientName: 'Vortex Logistics', clientId: 'c5' },
  { id: 'ev7', title: 'Team Weekly Standup', date: '2026-04-07', time: '09:00', type: 'meeting' },
  { id: 'ev8', title: 'Invoice Batch — April', date: '2026-04-15', type: 'deadline' },
  { id: 'ev9', title: 'Nova Digital Onboarding Call', date: '2026-04-09', time: '11:00', type: 'call', clientName: 'Nova Digital', clientId: 'c11' },
  { id: 'ev10', title: 'Skyforge Meta Campaign Review', date: '2026-04-10', time: '14:30', type: 'review', clientName: 'Skyforge Studios', clientId: 'c2' },
  { id: 'ev11', title: 'Dr. Ambedkar Jayanti', date: '2026-04-14', type: 'holiday' },
  { id: 'ev12', title: 'Zenith Email Flows Sign-Off', date: '2026-04-11', time: '12:00', type: 'review', clientName: 'Zenith Retail', clientId: 'c8' },
  { id: 'ev13', title: 'April Performance Deep-Dive', date: '2026-04-18', time: '10:00', type: 'review' },
  { id: 'ev14', title: 'Titan Edu Ads Launch', date: '2026-04-20', time: '09:00', type: 'deadline', clientName: 'Titan Edu', clientId: 'c10' },
  { id: 'ev15', title: 'Luminary Labs Social Strategy', date: '2026-04-22', time: '15:00', type: 'meeting', clientName: 'Luminary Labs', clientId: 'c9' },
  { id: 'ev16', title: 'Team Monthly Retrospective', date: '2026-04-25', time: '17:00', type: 'meeting' },
  { id: 'ev17', title: 'Orbit Systems Reactivation Call', date: '2026-04-28', time: '11:00', type: 'call', clientName: 'Orbit Systems', clientId: 'c12' },
]

// ── Invoices ──────────────────────────────────
export const mockInvoices: Invoice[] = [
  { id: 'inv1', invoiceNumber: 'INV-0042', clientId: 'c1', clientName: 'Astra Fintech', amount: 220000, tax: 39600, total: 259600, status: 'paid', issuedAt: '2026-03-01', dueDate: '2026-03-31', paidAt: '2026-04-04', items: [{ description: 'Google Ads Management — March', quantity: 1, rate: 120000, amount: 120000 }, { description: 'SEO Retainer — March', quantity: 1, rate: 60000, amount: 60000 }, { description: 'Social Media Management', quantity: 1, rate: 40000, amount: 40000 }] },
  { id: 'inv2', invoiceNumber: 'INV-0043', clientId: 'c2', clientName: 'Skyforge Studios', amount: 185000, tax: 33300, total: 218300, status: 'paid', issuedAt: '2026-03-01', dueDate: '2026-03-31', paidAt: '2026-03-28', items: [{ description: 'Meta Ads Management — March', quantity: 1, rate: 120000, amount: 120000 }, { description: 'Email Marketing — March', quantity: 1, rate: 65000, amount: 65000 }] },
  { id: 'inv3', invoiceNumber: 'INV-0044', clientId: 'c3', clientName: 'Blaze Commerce', amount: 175000, tax: 31500, total: 206500, status: 'sent', issuedAt: '2026-04-01', dueDate: '2026-04-30', items: [{ description: 'Google Ads + Meta Ads Management — April', quantity: 1, rate: 140000, amount: 140000 }, { description: 'SEO Retainer — April', quantity: 1, rate: 35000, amount: 35000 }] },
  { id: 'inv4', invoiceNumber: 'INV-0045', clientId: 'c4', clientName: 'Nexora Health', amount: 140000, tax: 25200, total: 165200, status: 'sent', issuedAt: '2026-04-01', dueDate: '2026-04-30', items: [{ description: 'SEO Programme — April', quantity: 1, rate: 80000, amount: 80000 }, { description: 'Social Media — April', quantity: 1, rate: 60000, amount: 60000 }] },
  { id: 'inv5', invoiceNumber: 'INV-0040', clientId: 'c12', clientName: 'Orbit Systems', amount: 80000, tax: 14400, total: 94400, status: 'overdue', issuedAt: '2026-02-25', dueDate: '2026-03-20', items: [{ description: 'Google Ads + Social — February', quantity: 1, rate: 80000, amount: 80000 }] },
  { id: 'inv6', invoiceNumber: 'INV-0039', clientId: 'c5', clientName: 'Vortex Logistics', amount: 130000, tax: 23400, total: 153400, status: 'overdue', issuedAt: '2026-02-28', dueDate: '2026-03-25', items: [{ description: 'Google Ads Management — February', quantity: 1, rate: 90000, amount: 90000 }, { description: 'Email Marketing', quantity: 1, rate: 40000, amount: 40000 }] },
  { id: 'inv7', invoiceNumber: 'INV-0046', clientId: 'c5', clientName: 'Vortex Logistics', amount: 130000, tax: 23400, total: 153400, status: 'sent', issuedAt: '2026-04-01', dueDate: '2026-04-30', items: [{ description: 'Google Ads + Email — April', quantity: 1, rate: 130000, amount: 130000 }] },
  { id: 'inv8', invoiceNumber: 'INV-0047', clientId: 'c6', clientName: 'Pixel Republic', amount: 120000, tax: 21600, total: 141600, status: 'sent', issuedAt: '2026-04-01', dueDate: '2026-04-30', items: [{ description: 'Meta Ads + Social + Email — April', quantity: 1, rate: 120000, amount: 120000 }] },
  { id: 'inv9', invoiceNumber: 'INV-0041', clientId: 'c7', clientName: 'CoreEdge Tech', amount: 115000, tax: 20700, total: 135700, status: 'paid', issuedAt: '2026-03-01', dueDate: '2026-03-31', paidAt: '2026-03-30', items: [{ description: 'Google Ads + SEO — March', quantity: 1, rate: 115000, amount: 115000 }] },
  { id: 'inv10', invoiceNumber: 'INV-0038', clientId: 'c8', clientName: 'Zenith Retail', amount: 110000, tax: 19800, total: 129800, status: 'draft', issuedAt: '2026-04-02', dueDate: '2026-04-30', items: [{ description: 'Meta Ads + Email — April', quantity: 1, rate: 110000, amount: 110000 }] },
  { id: 'inv11', invoiceNumber: 'INV-0048', clientId: 'c10', clientName: 'Titan Edu', amount: 90000, tax: 16200, total: 106200, status: 'draft', issuedAt: '2026-04-02', dueDate: '2026-05-01', items: [{ description: 'Google Ads Management — April', quantity: 1, rate: 90000, amount: 90000 }] },
  { id: 'inv12', invoiceNumber: 'INV-0049', clientId: 'c11', clientName: 'Nova Digital', amount: 100000, tax: 18000, total: 118000, status: 'sent', issuedAt: '2026-04-01', dueDate: '2026-04-30', items: [{ description: 'Meta Ads + SEO Onboarding — April', quantity: 1, rate: 100000, amount: 100000 }] },
]

// ── Expenses ──────────────────────────────────
export const mockExpenses: Expense[] = [
  { id: 'exp1', description: 'Google Workspace (annual)', category: 'Software', amount: 12000, date: '2026-04-01', vendor: 'Google', approvedBy: 'HJ' },
  { id: 'exp2', description: 'Semrush subscription', category: 'Software', amount: 18000, date: '2026-04-01', vendor: 'Semrush', approvedBy: 'HJ' },
  { id: 'exp3', description: 'Figma Pro seats (3)', category: 'Software', amount: 9000, date: '2026-04-01', vendor: 'Figma', approvedBy: 'Bunny' },
  { id: 'exp4', description: 'Slack Pro', category: 'Software', amount: 6500, date: '2026-04-01', vendor: 'Slack', approvedBy: 'HJ' },
  { id: 'exp5', description: 'Meta Ads test budget — internal', category: 'Advertising', amount: 15000, date: '2026-04-02', vendor: 'Meta', approvedBy: 'Darshu' },
  { id: 'exp6', description: 'Google Ads test budget — internal', category: 'Advertising', amount: 10000, date: '2026-04-02', vendor: 'Google', approvedBy: 'Darshu' },
  { id: 'exp7', description: 'Salary — Priya', category: 'Salaries', amount: 55000, date: '2026-04-01', vendor: 'Internal', approvedBy: 'HJ' },
  { id: 'exp8', description: 'Salary — Pooja', category: 'Salaries', amount: 60000, date: '2026-04-01', vendor: 'Internal', approvedBy: 'HJ' },
  { id: 'exp9', description: 'Salary — Rahul', category: 'Salaries', amount: 52000, date: '2026-04-01', vendor: 'Internal', approvedBy: 'HJ' },
  { id: 'exp10', description: 'Salary — Amit', category: 'Salaries', amount: 48000, date: '2026-04-01', vendor: 'Internal', approvedBy: 'HJ' },
  { id: 'exp11', description: 'Office rent — April', category: 'Office', amount: 25000, date: '2026-04-01', vendor: 'DLF Properties', approvedBy: 'HJ' },
  { id: 'exp12', description: 'Office supplies & stationery', category: 'Office', amount: 3500, date: '2026-04-03', vendor: 'Amazon Business', approvedBy: 'HJ' },
  { id: 'exp13', description: 'Client dinner — Blaze Commerce', category: 'Travel', amount: 4200, date: '2026-04-02', vendor: 'Smoke House Deli', approvedBy: 'HJ' },
  { id: 'exp14', description: 'Mumbai flight — client meetings', category: 'Travel', amount: 8500, date: '2026-04-07', vendor: 'IndiGo', approvedBy: 'HJ' },
  { id: 'exp15', description: 'Content creation tools — Canva Pro', category: 'Marketing', amount: 4000, date: '2026-04-01', vendor: 'Canva', approvedBy: 'Bunny' },
  { id: 'exp16', description: 'Salary — Dev', category: 'Salaries', amount: 45000, date: '2026-04-01', vendor: 'Internal', approvedBy: 'HJ' },
]


// ── Attendance Records ────────────────────────
function att(
  id: string, memberId: string, memberName: string, date: string,
  checkIn: string | null, checkOut: string | null,
  status: AttendanceRecord['status'], hoursWorked: number, notes?: string
): AttendanceRecord {
  return { id, memberId, memberName, date, checkIn, checkOut, status, hoursWorked, notes }
}

export const mockAttendance: AttendanceRecord[] = [
  // ── Bunny ──
  att('ar-b01','tm-bunny','Bunny','2026-03-10','09:00','19:00','present',10),
  att('ar-b02','tm-bunny','Bunny','2026-03-11','09:05','18:55','present',9.8),
  att('ar-b03','tm-bunny','Bunny','2026-03-12','09:00','19:30','present',10.5),
  att('ar-b04','tm-bunny','Bunny','2026-03-13','09:10','18:50','present',9.7),
  att('ar-b05','tm-bunny','Bunny','2026-03-16','09:00','19:00','present',10),
  att('ar-b06','tm-bunny','Bunny','2026-03-17','09:15','19:15','present',10),
  att('ar-b07','tm-bunny','Bunny','2026-03-18','09:00','19:00','present',10),
  att('ar-b08','tm-bunny','Bunny','2026-03-19','09:30','14:00','half-day',4.5,'Family commitment'),
  att('ar-b09','tm-bunny','Bunny','2026-03-20','09:00','19:00','present',10),
  att('ar-b10','tm-bunny','Bunny','2026-03-23','09:00','19:00','present',10),
  att('ar-b11','tm-bunny','Bunny','2026-03-24','09:05','19:05','present',10),
  att('ar-b12','tm-bunny','Bunny','2026-03-25','09:00','19:00','present',10),
  att('ar-b13','tm-bunny','Bunny','2026-03-26','09:00','19:00','present',10),
  att('ar-b14','tm-bunny','Bunny','2026-03-27','09:00','19:00','present',10),
  att('ar-b15','tm-bunny','Bunny','2026-03-30','09:00','19:00','present',10),
  att('ar-b16','tm-bunny','Bunny','2026-03-31','09:10','19:10','present',10),
  att('ar-b17','tm-bunny','Bunny','2026-04-01','09:00','19:00','present',10),
  att('ar-b18','tm-bunny','Bunny','2026-04-02','09:00','19:00','present',10),
  att('ar-b19','tm-bunny','Bunny','2026-04-03','09:00','18:30','present',9.5),
  att('ar-b20','tm-bunny','Bunny','2026-04-06','09:00','19:00','present',10),
  att('ar-b21','tm-bunny','Bunny','2026-04-07','09:00','19:00','present',10),
  att('ar-b22','tm-bunny','Bunny','2026-04-08','09:00','19:00','present',10),
  att('ar-b23','tm-bunny','Bunny','2026-04-09','09:00',null,'present',0),
  // ── HJ ──
  att('ar-h01','tm-hj','HJ','2026-03-10','09:30','20:00','present',10.5),
  att('ar-h02','tm-hj','HJ','2026-03-11','09:30','20:00','present',10.5),
  att('ar-h03','tm-hj','HJ','2026-03-12','09:30','20:00','present',10.5),
  att('ar-h04','tm-hj','HJ','2026-03-13','09:30','19:30','present',10),
  att('ar-h05','tm-hj','HJ','2026-03-16','09:30','20:00','present',10.5),
  att('ar-h06','tm-hj','HJ','2026-03-17','09:30','20:00','present',10.5),
  att('ar-h07','tm-hj','HJ','2026-03-18',null,null,'leave',0,'Planned leave'),
  att('ar-h08','tm-hj','HJ','2026-03-19',null,null,'leave',0,'Planned leave'),
  att('ar-h09','tm-hj','HJ','2026-03-20','09:30','20:00','present',10.5),
  att('ar-h10','tm-hj','HJ','2026-03-23','09:30','20:00','present',10.5),
  att('ar-h11','tm-hj','HJ','2026-03-24','09:30','20:00','present',10.5),
  att('ar-h12','tm-hj','HJ','2026-03-25','09:30','20:00','present',10.5),
  att('ar-h13','tm-hj','HJ','2026-03-26','09:30','20:00','present',10.5),
  att('ar-h14','tm-hj','HJ','2026-03-27','09:30','20:00','present',10.5),
  att('ar-h15','tm-hj','HJ','2026-03-30','09:30','20:00','present',10.5),
  att('ar-h16','tm-hj','HJ','2026-03-31','09:30','20:00','present',10.5),
  att('ar-h17','tm-hj','HJ','2026-04-01','09:30','20:00','present',10.5),
  att('ar-h18','tm-hj','HJ','2026-04-02','09:30','20:00','present',10.5),
  att('ar-h19','tm-hj','HJ','2026-04-03','09:30','20:00','present',10.5),
  att('ar-h20','tm-hj','HJ','2026-04-06','09:30','20:00','present',10.5),
  att('ar-h21','tm-hj','HJ','2026-04-07','09:30','20:00','present',10.5),
  att('ar-h22','tm-hj','HJ','2026-04-08','09:30','20:00','present',10.5),
  att('ar-h23','tm-hj','HJ','2026-04-09','09:30',null,'present',0),
  // ── Darshu ──
  att('ar-d01','tm-darshu','Darshu','2026-03-10','09:00','19:00','present',10),
  att('ar-d02','tm-darshu','Darshu','2026-03-11','09:00','19:00','present',10),
  att('ar-d03','tm-darshu','Darshu','2026-03-12','09:00','19:00','present',10),
  att('ar-d04','tm-darshu','Darshu','2026-03-13','09:00','19:00','present',10),
  att('ar-d05','tm-darshu','Darshu','2026-03-16','09:00','19:00','present',10),
  att('ar-d06','tm-darshu','Darshu','2026-03-17','09:00','19:00','present',10),
  att('ar-d07','tm-darshu','Darshu','2026-03-18','09:00','19:00','present',10),
  att('ar-d08','tm-darshu','Darshu','2026-03-19','09:00','19:00','present',10),
  att('ar-d09','tm-darshu','Darshu','2026-03-20','09:15','13:00','half-day',3.75,'Dentist appointment'),
  att('ar-d10','tm-darshu','Darshu','2026-03-23','09:00','19:00','present',10),
  att('ar-d11','tm-darshu','Darshu','2026-03-24','09:00','19:00','present',10),
  att('ar-d12','tm-darshu','Darshu','2026-03-25','09:00','19:00','present',10),
  att('ar-d13','tm-darshu','Darshu','2026-03-26','09:00','19:00','present',10),
  att('ar-d14','tm-darshu','Darshu','2026-03-27','09:00','19:00','present',10),
  att('ar-d15','tm-darshu','Darshu','2026-03-30','09:00','19:00','present',10),
  att('ar-d16','tm-darshu','Darshu','2026-03-31','09:00','19:00','present',10),
  att('ar-d17','tm-darshu','Darshu','2026-04-01','09:00','19:00','present',10),
  att('ar-d18','tm-darshu','Darshu','2026-04-02','09:00','19:00','present',10),
  att('ar-d19','tm-darshu','Darshu','2026-04-03','09:00','19:00','present',10),
  att('ar-d20','tm-darshu','Darshu','2026-04-06','09:00','19:00','present',10),
  att('ar-d21','tm-darshu','Darshu','2026-04-07','09:00','19:00','present',10),
  att('ar-d22','tm-darshu','Darshu','2026-04-08','09:00','19:00','present',10),
  att('ar-d23','tm-darshu','Darshu','2026-04-09','09:00',null,'present',0),
  // ── Rahul ──
  att('ar-r01','tm-rahul','Rahul','2026-03-10','09:30','18:30','present',9),
  att('ar-r02','tm-rahul','Rahul','2026-03-11','09:30','18:30','present',9),
  att('ar-r03','tm-rahul','Rahul','2026-03-12','10:15','18:30','late',8.25,'Traffic'),
  att('ar-r04','tm-rahul','Rahul','2026-03-13','09:30','18:30','present',9),
  att('ar-r05','tm-rahul','Rahul','2026-03-16','09:30','18:30','present',9),
  att('ar-r06','tm-rahul','Rahul','2026-03-17','09:30','18:30','present',9),
  att('ar-r07','tm-rahul','Rahul','2026-03-18','09:30','18:30','present',9),
  att('ar-r08','tm-rahul','Rahul','2026-03-19',null,null,'absent',0,'Sick - fever'),
  att('ar-r09','tm-rahul','Rahul','2026-03-20',null,null,'absent',0,'Sick - fever'),
  att('ar-r10','tm-rahul','Rahul','2026-03-23','09:30','18:30','present',9),
  att('ar-r11','tm-rahul','Rahul','2026-03-24','09:30','18:30','present',9),
  att('ar-r12','tm-rahul','Rahul','2026-03-25','10:00','18:30','late',8.5),
  att('ar-r13','tm-rahul','Rahul','2026-03-26','09:30','18:30','present',9),
  att('ar-r14','tm-rahul','Rahul','2026-03-27','09:30','18:30','present',9),
  att('ar-r15','tm-rahul','Rahul','2026-03-30','09:30','18:30','present',9),
  att('ar-r16','tm-rahul','Rahul','2026-03-31','09:30','18:30','present',9),
  att('ar-r17','tm-rahul','Rahul','2026-04-01','09:30','18:30','present',9),
  att('ar-r18','tm-rahul','Rahul','2026-04-02','09:30','18:30','present',9),
  att('ar-r19','tm-rahul','Rahul','2026-04-03','09:30','18:30','present',9),
  att('ar-r20','tm-rahul','Rahul','2026-04-06','09:30','18:30','present',9),
  att('ar-r21','tm-rahul','Rahul','2026-04-07','09:30','18:30','present',9),
  att('ar-r22','tm-rahul','Rahul','2026-04-08','09:30','18:30','present',9),
  att('ar-r23','tm-rahul','Rahul','2026-04-09','09:30',null,'present',0),
  // ── Priya ──
  att('ar-p01','tm-priya','Priya','2026-03-10','10:00','19:00','present',9),
  att('ar-p02','tm-priya','Priya','2026-03-11','10:00','19:00','present',9),
  att('ar-p03','tm-priya','Priya','2026-03-12','10:00','19:00','present',9),
  att('ar-p04','tm-priya','Priya','2026-03-13','10:30','19:00','late',8.5,'Metro delay'),
  att('ar-p05','tm-priya','Priya','2026-03-16','10:00','19:00','present',9),
  att('ar-p06','tm-priya','Priya','2026-03-17','10:00','19:00','present',9),
  att('ar-p07','tm-priya','Priya','2026-03-18','10:00','19:00','present',9),
  att('ar-p08','tm-priya','Priya','2026-03-19','10:00','19:00','present',9),
  att('ar-p09','tm-priya','Priya','2026-03-20',null,null,'leave',0,'Casual leave'),
  att('ar-p10','tm-priya','Priya','2026-03-23','10:00','19:00','present',9),
  att('ar-p11','tm-priya','Priya','2026-03-24','10:45','19:00','late',8.25,'Overslept'),
  att('ar-p12','tm-priya','Priya','2026-03-25','10:00','19:00','present',9),
  att('ar-p13','tm-priya','Priya','2026-03-26','10:00','19:00','present',9),
  att('ar-p14','tm-priya','Priya','2026-03-27','10:00','19:00','present',9),
  att('ar-p15','tm-priya','Priya','2026-03-30','10:00','19:00','present',9),
  att('ar-p16','tm-priya','Priya','2026-03-31','10:00','19:00','present',9),
  att('ar-p17','tm-priya','Priya','2026-04-01','10:00','19:00','present',9),
  att('ar-p18','tm-priya','Priya','2026-04-02','10:00','19:00','present',9),
  att('ar-p19','tm-priya','Priya','2026-04-03','10:00','19:00','present',9),
  att('ar-p20','tm-priya','Priya','2026-04-06','10:00','19:00','present',9),
  att('ar-p21','tm-priya','Priya','2026-04-07','10:00','19:00','present',9),
  att('ar-p22','tm-priya','Priya','2026-04-08','10:00','19:00','present',9),
  att('ar-p23','tm-priya','Priya','2026-04-09','10:00',null,'present',0),
  // ── Pooja ──
  att('ar-po01','tm-pooja','Pooja','2026-03-10','09:00','18:00','present',9),
  att('ar-po02','tm-pooja','Pooja','2026-03-11','09:00','18:00','present',9),
  att('ar-po03','tm-pooja','Pooja','2026-03-12','09:00','18:00','present',9),
  att('ar-po04','tm-pooja','Pooja','2026-03-13','09:00','18:00','present',9),
  att('ar-po05','tm-pooja','Pooja','2026-03-16','09:00','18:00','present',9),
  att('ar-po06','tm-pooja','Pooja','2026-03-17','09:00','18:00','present',9),
  att('ar-po07','tm-pooja','Pooja','2026-03-18','09:00','18:00','present',9),
  att('ar-po08','tm-pooja','Pooja','2026-03-19','09:00','18:00','present',9),
  att('ar-po09','tm-pooja','Pooja','2026-03-20','09:00','13:30','half-day',4.5,'Personal work'),
  att('ar-po10','tm-pooja','Pooja','2026-03-23','09:00','18:00','present',9),
  att('ar-po11','tm-pooja','Pooja','2026-03-24','09:00','18:00','present',9),
  att('ar-po12','tm-pooja','Pooja','2026-03-25','09:00','18:00','present',9),
  att('ar-po13','tm-pooja','Pooja','2026-03-26','09:00','18:00','present',9),
  att('ar-po14','tm-pooja','Pooja','2026-03-27','09:00','18:00','present',9),
  att('ar-po15','tm-pooja','Pooja','2026-03-30','09:00','18:00','present',9),
  att('ar-po16','tm-pooja','Pooja','2026-03-31','09:00','18:00','present',9),
  att('ar-po17','tm-pooja','Pooja','2026-04-01','09:00','18:00','present',9),
  att('ar-po18','tm-pooja','Pooja','2026-04-02','09:00','18:00','present',9),
  att('ar-po19','tm-pooja','Pooja','2026-04-03','09:00','18:00','present',9),
  att('ar-po20','tm-pooja','Pooja','2026-04-06','09:00','18:00','present',9),
  att('ar-po21','tm-pooja','Pooja','2026-04-07','09:00','18:00','present',9),
  att('ar-po22','tm-pooja','Pooja','2026-04-08','09:00','18:00','present',9),
  att('ar-po23','tm-pooja','Pooja','2026-04-09','09:00',null,'present',0),
  // ── Amit ──
  att('ar-a01','tm-amit','Amit','2026-03-10','09:30','18:30','present',9),
  att('ar-a02','tm-amit','Amit','2026-03-11','09:30','18:30','present',9),
  att('ar-a03','tm-amit','Amit','2026-03-12','09:30','18:30','present',9),
  att('ar-a04','tm-amit','Amit','2026-03-13','09:30','18:30','present',9),
  att('ar-a05','tm-amit','Amit','2026-03-16','10:00','18:30','late',8.5,'Car trouble'),
  att('ar-a06','tm-amit','Amit','2026-03-17','09:30','18:30','present',9),
  att('ar-a07','tm-amit','Amit','2026-03-18','09:30','18:30','present',9),
  att('ar-a08','tm-amit','Amit','2026-03-19','09:30','18:30','present',9),
  att('ar-a09','tm-amit','Amit','2026-03-20','09:30','18:30','present',9),
  att('ar-a10','tm-amit','Amit','2026-03-23',null,null,'leave',0,'Casual leave'),
  att('ar-a11','tm-amit','Amit','2026-03-24',null,null,'leave',0,'Casual leave'),
  att('ar-a12','tm-amit','Amit','2026-03-25','09:30','18:30','present',9),
  att('ar-a13','tm-amit','Amit','2026-03-26','09:30','18:30','present',9),
  att('ar-a14','tm-amit','Amit','2026-03-27','09:30','18:30','present',9),
  att('ar-a15','tm-amit','Amit','2026-03-30','09:30','18:30','present',9),
  att('ar-a16','tm-amit','Amit','2026-03-31','09:30','18:30','present',9),
  att('ar-a17','tm-amit','Amit','2026-04-01','09:30','18:30','present',9),
  att('ar-a18','tm-amit','Amit','2026-04-02','09:30','18:30','present',9),
  att('ar-a19','tm-amit','Amit','2026-04-03','09:30','18:30','present',9),
  att('ar-a20','tm-amit','Amit','2026-04-06','09:30','18:30','present',9),
  att('ar-a21','tm-amit','Amit','2026-04-07','10:15','18:30','late',8.25,'Client call ran late'),
  att('ar-a22','tm-amit','Amit','2026-04-08','09:30','18:30','present',9),
  att('ar-a23','tm-amit','Amit','2026-04-09','09:30',null,'present',0),
  // ── Dev ──
  att('ar-v01','tm-dev','Dev','2026-03-10','10:00','19:00','present',9),
  att('ar-v02','tm-dev','Dev','2026-03-11','10:00','19:00','present',9),
  att('ar-v03','tm-dev','Dev','2026-03-12','10:00','19:00','present',9),
  att('ar-v04','tm-dev','Dev','2026-03-13','10:00','19:00','present',9),
  att('ar-v05','tm-dev','Dev','2026-03-16','10:00','19:00','present',9),
  att('ar-v06','tm-dev','Dev','2026-03-17','10:00','19:00','present',9),
  att('ar-v07','tm-dev','Dev','2026-03-18',null,null,'absent',0,'No show'),
  att('ar-v08','tm-dev','Dev','2026-03-19','10:00','19:00','present',9),
  att('ar-v09','tm-dev','Dev','2026-03-20','10:00','19:00','present',9),
  att('ar-v10','tm-dev','Dev','2026-03-23','10:00','19:00','present',9),
  att('ar-v11','tm-dev','Dev','2026-03-24','10:00','19:00','present',9),
  att('ar-v12','tm-dev','Dev','2026-03-25','10:00','19:00','present',9),
  att('ar-v13','tm-dev','Dev','2026-03-26','11:00','19:00','late',8,'Doctor visit'),
  att('ar-v14','tm-dev','Dev','2026-03-27','10:00','19:00','present',9),
  att('ar-v15','tm-dev','Dev','2026-03-30','10:00','19:00','present',9),
  att('ar-v16','tm-dev','Dev','2026-03-31','10:00','19:00','present',9),
  att('ar-v17','tm-dev','Dev','2026-04-01','10:00','19:00','present',9),
  att('ar-v18','tm-dev','Dev','2026-04-02',null,null,'absent',0,'Unplanned absence'),
  att('ar-v19','tm-dev','Dev','2026-04-03','10:00','19:00','present',9),
  att('ar-v20','tm-dev','Dev','2026-04-06','10:00','19:00','present',9),
  att('ar-v21','tm-dev','Dev','2026-04-07','10:00','19:00','present',9),
  att('ar-v22','tm-dev','Dev','2026-04-08','10:00','19:00','present',9),
  att('ar-v23','tm-dev','Dev','2026-04-09','10:00',null,'present',0),
]

// ── Leave Balances ────────────────────────────
export const mockLeaveBalances: LeaveBalance[] = [
  { memberId: 'tm-bunny',  memberName: 'Bunny',  casual: { total: 12, used: 1 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 0 } },
  { memberId: 'tm-hj',     memberName: 'HJ',     casual: { total: 12, used: 2 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 0 } },
  { memberId: 'tm-darshu', memberName: 'Darshu', casual: { total: 12, used: 1 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 0 } },
  { memberId: 'tm-rahul',  memberName: 'Rahul',  casual: { total: 12, used: 0 },  sick: { total: 7, used: 2 }, earned: { total: 15, used: 3 } },
  { memberId: 'tm-priya',  memberName: 'Priya',  casual: { total: 12, used: 1 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 5 } },
  { memberId: 'tm-pooja',  memberName: 'Pooja',  casual: { total: 12, used: 1 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 2 } },
  { memberId: 'tm-amit',   memberName: 'Amit',   casual: { total: 12, used: 2 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 4 } },
  { memberId: 'tm-dev',    memberName: 'Dev',    casual: { total: 12, used: 0 },  sick: { total: 7, used: 0 }, earned: { total: 15, used: 1 } },
]
